@if (model.pageReady) {
  <div class="login-bg bg-img" style="overflow-y: scroll;">
    <!--<div class='pin'></div>-->
    <!--<div class='pulse'></div>-->
    @if (!model.showResetForm) {
      <div class="container">
        <div class="row loginOuterWrap">
          <div class="col-md-6 col-md-offset-4 login-mid ui-sm-12">
            <div class="login-header ui-g-12">
              <div class="tiger-logo animated fadeIn">
              </div>
              <h1 class="animated fadeIn">Sign in</h1>
              <div class="login-error-wrap ui-g-12">
                <app-generic-service-complete [showError]="model.showErrorMessage" [errorText]="model.loginErrorMessage"></app-generic-service-complete>
                <app-generic-service-complete [showError]="model.logoutReason ? true : false " [errorText]="model.logoutReason"></app-generic-service-complete>
              </div>
            </div>
            <form>
              <div class="login-inner ui-g-12 ui-sm-12">
                <div class="form-group">
                  <label for="username" class="hidden">Email</label>
                  <div class="login-inputWrap first-input">
                    <input type="text" class="form-control" id="username" name="username" placeholder="Email" [formControl]="model.loginForm.controls['username'] | formControl" (keydown)="model.doEmailChangeEvent($event)">
                    <span class="icon"><i class="fal fa-lock-alt"></i></span>
                    <app-validation-notification class="login-required-user" [control]="model.loginForm.controls['username'] | formControl"></app-validation-notification>
                  </div>
                </div>
                @if (model.showPassword) {
                  <div class="form-group">
                    <label for="password" class="hidden">Password</label>
                    <div class="login-inputWrap second-input">
                      <input type="password" class="form-control" id="password" name="password" placeholder="Password" [formControl]="model.loginForm.controls['password'] | formControl">
                      <span class="icon"><i class="fal fa-key"></i></span>
                      <app-validation-notification class="login-required-pw" [control]="model.loginForm.controls['password'] | formControl"></app-validation-notification>
                    </div>
                  </div>
                }
                <div class="login-wrap ui-sm-12">
                  @if (!model.showPassword) {
                    <button type="submit"
                      class="btn position-rel pull-right login-btn gradient-border ui-sm-12"
                      (click)="onNextLoginForm(model.loginForm)">
                      Next
                    </button>
                  }
                  @if (model.showPassword) {
                    <app-form-throbber-button id="login-button"
                      [throbbingFlag]="model.inProgressFlag"
                      [throbbingButtonText]="'Signing In...'"
                      [buttonText]="'Sign in'"
                      [buttonClass]="'pull-right login-btn gradient-border ui-sm-12'"
                      [enabled]="true"
                      [form]="model.loginForm"
                      (SubmitFormEvent)="onSubmitLoginForm(model.loginForm)">
                    </app-form-throbber-button>
                  }
                  <a class="forgotPW ui-sm-12" href="javascript:void(0)" (click)="model.toggleResetForm(true)">Forgot Password?</a>
                </div>
              </div>
            </form>
          </div>
          <div class="clearfix"> </div>
          <div class="col-md-12 col-lg-12 col-md-offset-4 login-links ui-sm-12">
            <a class="text-center" routerLink="/privacyPolicy">Privacy Policy | </a>
            <a class="text-center" routerLink="/privacyPolicy/cookie"> Cookies</a>
          </div>
        </div>
      </div>
    }
    <!--reset-->
    @if (model.showResetForm) {
      <div class="container">
        <div class="row loginOuterWrap">
          <div class="col-md-5 ui-sm-12 col-md-offset-4 login-mid animated fadeIn">
            <div class="login-header ui-g-12">
              <div class="tiger-logo animated fadeIn">
              </div>
              <h1>Password Reset</h1>
            </div>
            <div>
              <app-generic-service-complete
                [showError]="model.showResetErrorMessage"
                [errorText]="'There was an issue generating your reset request. Please contact your TigerEye Administrator'"
                [showSuccess]="model.showResetSuccessMessage"
                [successText]="'Your password reset has been sent. If the email address you provided is a valid email address in our system, you should receive an email to reset your password shortly.'">
              </app-generic-service-complete>
            </div>
            <form>
              <div class="login-inner ui-g-12 ui-sm-12">
                <div class="form-group">
                  <label class="hidden" for="emailusername">Email Address: </label>
                  <div class="login-inputWrap">
                    <input type="text" class="form-control" id="emailusername" name="emailusername" placeholder="Email Address for Password Reset" [formControl]="model.resetForm.controls['emailUsername'] | formControl">
                    <span class="icon"><i class="fal fa-lock-alt"></i></span>
                    <app-validation-notification class="login-required" [control]="model.resetForm.controls['emailUsername'] | formControl"></app-validation-notification>
                  </div>
                </div>
                <div class="login-wrap ui-sm-12">
                  <app-form-throbber-button
                    [throbbingFlag]="model.resetInProgressFlag"
                    [throbbingButtonText]="'Processing Request'"
                    [buttonText]="'Request Reset'"
                    [buttonClass]="'pull-right login-btn ui-sm-12'"
                    [enabled]="true"
                    [form]="model.resetForm"
                    (SubmitFormEvent)="onSubmitResetForm(model.resetForm)">
                  </app-form-throbber-button>
                  <a class="forgotPW ui-sm-12" href="javascript:void(0)" (click)="model.toggleResetForm(false)">Return to Login</a>
                </div>
              </div>
            </form>
          </div>
          <div class="clearfix"> </div>
          <div class="col-md-12 col-lg-12 col-md-offset-4 login-links ui-sm-12">
            <a class="text-center" routerLink="/privacyPolicy">Privacy Policy | </a>
            <a class="text-center" routerLink="/privacyPolicy/cookie"> Cookies</a>
          </div>
        </div>
      </div>
    }
  </div>
}

<app-modal [contentStyleInput]="{'min-width':'850px'}" id="accept-terms-modal">
  <span class="app-modal-header">
    Terms Of Use
  </span>
  <div class="app-modal-body">
    <app-privacy-policy></app-privacy-policy>
  </div>
  <div class="app-modal-footer">
    <div class="pull-right">
      <button type="button" class="btn btn-primary" (click)="model.acceptTermsOfUse()">Accept</button>
      <button type="button" class="btn btn-default" (click)="model.declineTermsOfUse()">Decline</button>
    </div>
  </div>
</app-modal>

<app-modal [contentStyleInput]="{'min-width':'850px'}" id="force-password-reset-modal">
  <span class="app-modal-header">
    Password Expired
  </span>
  <div class="app-modal-body">
    <p>
      Your Password has Expired.
      <br /> <br />
      Please click "OK" below to initiate the process and receive an email to reset your password.
    </p>
  </div>
  <div class="app-modal-footer">
    <div class="pull-right">
      <button type="button" class="btn btn-primary" (click)="model.sendPasswordReset()">OK</button>
    </div>
  </div>
</app-modal>



